import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useTeamsPermissionsService } from '@atlassian/teams-common/use-teams-permissions';
import { PeopleMenuOverrides } from '../../types';
export var usePeopleAndTeamsConfigurationOverrides = function usePeopleAndTeamsConfigurationOverrides(teamPermissionCheckEnabled, orgId, teamPermissionsProps) {
  var _useTeamsPermissionsS = useTeamsPermissionsService(orgId, {
      enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    }),
    teamPermissionsFromHook = _useTeamsPermissionsS.permissions;
  var teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
  return {
    'people-menu': [].concat(_toConsumableArray(!(teamPermissions !== null && teamPermissions !== void 0 && teamPermissions.canCreateTeams) ? [PeopleMenuOverrides.createTeamsDisabled] : []), _toConsumableArray(!(teamPermissions !== null && teamPermissions !== void 0 && teamPermissions.canViewTeams) ? [PeopleMenuOverrides.viewTeamsDisabled] : []))
  };
};